import { Badge } from '../../library/badge/badge';
import { IconButton } from '../../library/buttons/icon-button';
import { PersonIcon } from '../../library/icons/material/Person';
import { ButtonBase } from '../../library/buttons/button-base';
import { ArrowDropDownIcon } from '../../library/icons/material/ArrowDropDown';
import { ReactElement } from 'react';
import { ListboxItemProps } from '../../library/forms/listbox/item';
import { NavbarAuthMenu } from './navbar-auth-menu';

export interface NavbarAuthUserProps {
  items?: ReactElement<ListboxItemProps>[];
  user?: any;
  variant?: string;
}

export function NavbarAuthUser({ items = [], user: propUser }: NavbarAuthUserProps) {
  if (!propUser) return null;

  const hasUnreadNotif = !!propUser.unread_notifications_count;
  const avatarUrl = propUser.avatar || propUser.avatar_url;
  const displayName = propUser.name || propUser.display_name;

  const mobileButton = (
    <IconButton
      size="md"
      className="md:hidden"
      role="presentation"
      aria-label="toggle authentication menu"
      badge={
        hasUnreadNotif ? (
          <Badge>{propUser.unread_notifications_count}</Badge>
        ) : undefined
      }
    >
      {avatarUrl ? (
        // FORÇANDO PIXELS REAIS: 32x32
        <img 
          src={avatarUrl} 
          alt={displayName} 
          className="h-[32px] w-[32px] rounded-full object-cover border border-white/10" 
        />
      ) : (
        <PersonIcon className="h-[24px] w-[24px]" />
      )}
    </IconButton>
  );

  const desktopButton = (
    <ButtonBase className="flex items-center max-md:hidden" role="presentation">
      {avatarUrl ? (
          // FORÇANDO PIXELS REAIS: 40x40 (Um pouco maior que o mobile para o desktop)
          <img
            className="mr-3 h-[27px] w-[27px] flex-shrink-0 rounded object-cover border border-white/10 shadow-sm"
            src={avatarUrl}
            alt={displayName}
          />
      ) : (
          // Placeholder também travado em pixels
          <div className="mr-3 h-[27px] w-[27px] flex items-center justify-center rounded bg-zinc-800 border border-white/10 shadow-sm">
             <PersonIcon className="h-[24px] w-[24px] text-white/50" />
          </div>
      )}
      <span className="mr-2 block max-w-[150px] overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium">
        {displayName}
      </span>
      <ArrowDropDownIcon className="block icon-sm" />
    </ButtonBase>
  );

  return (
    <NavbarAuthMenu items={items}>
      <span role="button" className="flex items-center cursor-pointer">
        {mobileButton}
        {desktopButton}
      </span>
    </NavbarAuthMenu>
  );
}